import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-58">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-obsidian z-0" data-id="element-59">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,165,116,0.08)_0%,rgba(10,10,10,1)_70%)]" data-id="element-60" />

        {/* Animated Particles/Embers */}
        {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-amber-glow/40 rounded-full blur-[1px]" initial={{
        x: Math.random() * (typeof window !== 'undefined' ? window.innerWidth : 1000),
        y: Math.random() * (typeof window !== 'undefined' ? window.innerHeight : 800),
        opacity: 0
      }} animate={{
        y: [null, Math.random() * -100],
        opacity: [0, 0.8, 0]
      }} transition={{
        duration: 3 + Math.random() * 5,
        repeat: Infinity,
        delay: Math.random() * 5,
        ease: 'easeInOut'
      }} data-id="element-61" />)}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-63">
          <div className="mb-6 flex justify-center" data-id="element-64">
            <div className="h-px w-24 bg-gradient-to-r from-transparent via-amber-glow/50 to-transparent" data-id="element-65" />
          </div>

          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-parchment mb-6 tracking-tight leading-tight text-shadow-glow" data-id="element-66">
            Where Shadows <br data-id="element-67" />
            <span className="text-amber-glow/90" data-id="element-68">Gather</span>
          </h1>

          <p className="font-body text-xl md:text-2xl text-bone/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-69">
            A sanctuary for dark fantasy creators, gothic storytellers, and
            horror devotees. Ravenhold is the hearth where the macabre finds its
            voice.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-70">
            <Button variant="primary" data-id="element-71">Enter the Sanctum</Button>
            <Button variant="ghost" data-id="element-72">Read the Manifesto</Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-bone/40" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-73">
        <ChevronDown className="w-8 h-8" data-id="element-74" />
      </motion.div>

      {/* Decorative Rose SVG (Abstract) */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-obsidian to-transparent pointer-events-none z-20" data-id="element-75" />
    </section>;
}